import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { StepPlanInfoIdSchema } from '../step/step.types.js';
// ===== ID SCHEMAS =====
const SetPlanIdSchema = createIdSchema('setPlan');
const SetPlanTableSelectSchema = createStrictSchema()({
    id: SetPlanIdSchema,
    stepPlanId: StepPlanInfoIdSchema,
    setNumber: z.number(),
    targetWeightMetric: z.number().nullable(),
    targetRepsMetric: z.number().nullable(),
    targetDistanceMetric: z.number().nullable(),
    targetDurationMetric: z.number().nullable(),
    targetRepPaceMetric: z.number().nullable(),
    targetHeightMetric: z.number().nullable(),
    trackTime: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by other layers) =====
const SetPlanInfoSchema = SetPlanTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const SetPlanInfoIdSchema = SetPlanIdSchema;
export { SetPlanInfoIdSchema, SetPlanInfoSchema, SetPlanTableSelectSchema };
//# sourceMappingURL=set.types.js.map